import { render, staticRenderFns } from "./adminInvoices.vue?vue&type=template&id=2358c7d0&scoped=true&"
import script from "./adminInvoices.vue?vue&type=script&lang=js&"
export * from "./adminInvoices.vue?vue&type=script&lang=js&"
import style0 from "./adminInvoices.vue?vue&type=style&index=0&id=2358c7d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2358c7d0",
  null
  
)

export default component.exports